export const widths = {
  small: 180,
  medium: 260,
  large: 390
}
